import {Modal} from 'components/base-modal/Modal'
import {useFormik} from 'formik'
import {useNotification} from 'hooks/useNotification'
import {forwardRef, useImperativeHandle, useState} from 'react'
import {ErrorCode} from 'utility/http-utils'
import {AdminSchema} from './schema'
import {ValidationError} from 'components/validation-error/ValidationError'
import feathers from 'utility/client'

export const Admin = forwardRef((props, ref) => {
  const notify = useNotification()
  const {ModalProps = {}} = props
  const [visible, setVisible] = useState(false)
  const [properties, setProperties] = useState({})

  useImperativeHandle(ref, () => ({
    show: (_properties = {}) => {
      setProperties(_properties)
      setVisible(true)
    }
  }))

  const handleClose = () => {
    setVisible(false)
  }

  const formik = useFormik({
    initialValues: {
      firstName: '',
      lastName: '',
      email: ''
    },
    validationSchema: AdminSchema,
    onSubmit: async data => {
      feathers
        .service('user')
        .create({
          ...data,
          ...properties
        })
        .catch(e => {
          const notification =
            e.code === ErrorCode.Conflict
              ? 'User already exist, can not make existing user as admin!'
              : 'Something wrong, Please try again!'

          notify({
            notification,
            variant: 'danger'
          })
        })

      if (props.onCreated) {
        props.onCreated(data)
      }

      formik.resetForm()
      handleClose(false)
    },
    enableReinitialize: true
  })

  return (
    <Modal
      open={visible}
      onClose={handleClose}
      center
      title="Add Admin"
      confirmTitle="Save Admin"
      cancelTitle="Cancel"
      onCancel={handleClose}
      onConfirm={formik.handleSubmit}
      {...ModalProps}
    >
      <div className="row">
        <div className="col-md-6">
          <div className="form-group">
            <label>First Name</label>
            <input
              type="text"
              name="firstName"
              className="form-control"
              placeholder="First name"
              value={formik.values.firstName}
              onChange={formik.handleChange}
            />
            <ValidationError formik={formik} property="firstName" />
          </div>
        </div>
        <div className="col-md-6">
          <div className="form-group">
            <label>Last Name</label>
            <input
              type="text"
              name="lastName"
              className="form-control"
              placeholder="Last name"
              value={formik.values.lastName}
              onChange={formik.handleChange}
            />
            <ValidationError formik={formik} property="lastName" />
          </div>
        </div>
      </div>
      <div className="form-group">
        <label>Email</label>
        <input
          type="email"
          name="email"
          className="form-control"
          placeholder="Email"
          value={formik.values.email}
          onChange={formik.handleChange}
        />
        <ValidationError formik={formik} property="email" />
      </div>
    </Modal>
  )
})
